import * as Sentry from "@sentry/react"
import { SENTRY_DNS } from "./runtimeVariables"

export default function (enabled: boolean) {
  if (enabled) {
    Sentry.init({
      dsn: SENTRY_DNS,
      integrations: [new Sentry.BrowserTracing({})],
      environment: window.location.hostname.includes("deploy-preview")
        ? "deploy-preview"
        : "production",
      tracePropagationTargets: [
        "localhost",
        /https?:\/\/([a-z0-9]+[.])*flyp.co/,
      ],
      tracesSampleRate: 1.0,
      ignoreErrors: [/^FirebaseError/],
      beforeSend(event) {
        if (
          event.tags?.["user_email"] &&
          String(event.tags["user_email"]).endsWith("@flyp.co")
        ) {
          return null
        }
        return event
      },
    })
  }
}
